import React, { useEffect, useState } from "react";
import {
  SearchContainer,
  SearchInput,
  SearchIcon,
  CleanSearchIcon,
  Pagination,
  Grid,
  Column,
} from "./styles";
import { Select } from "semantic-ui-react";

const Controls = (props) => {
  return (
    <Grid columns={4}>
      <Column>
        <Pagination
          page={props.page}
          onChange={props.handleChange}
          count={Math.ceil(props.count / 30)}
          shape="rounded"
        />
      </Column>
    </Grid>
  );
};

export default Controls;
